import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "../../../UI/Button";

export default function WrapperSignupDetails({
  children,
  step,
  handleButton,
  isButtonDisabled,
}) {
  const navigate = useNavigate();

  const logout = async () => {
    localStorage.setItem("techsbook_customer_portal_token", '');
    await navigate("/login");
  };

  return (
    <div className="register__details">
      <div className="register__top">
        <div className="container">
          <NavLink to="/">
            <img src="/assets/logo.svg" alt="logo" />
          </NavLink>
        </div>
      </div>
      <div className="register__content">
        <div className="container">{children}</div>
      </div>
      <div className="register__bottom">
        <div className="register__btn">
          {step === "1" ? (
            <Button
              text="Log out"
              type="light"
              topPadding={12}
              bottomPadding={12}
              onClick={logout}
            />
          ) : (
            <Button
              text="Previous"
              type="light"
              topPadding={12}
              bottomPadding={12}
              onClick={() => {
                navigate(-1);
              }}
            />
          )}
        </div>
        <div className="register__steps">
          <div
            className={`register__step ${
              step === "1" || step === "2" ? "active" : ""
            } `}
          ></div>
          <div
            className={`register__step ${step === "2" ? "active" : ""} `}
          ></div>
          <div
            className={`register__step ${step === "3" ? "active" : ""} `}
          ></div>
        </div>
        <div className="register__btn">
          <Button
            text="Continue"
            type="primary"
            disabled={isButtonDisabled}
            topPadding={12}
            bottomPadding={12}
            onClick={handleButton}
          />
        </div>
      </div>
    </div>
  );
}
